// extracted by mini-css-extract-plugin
export default {"button":"ArrowButton_button__zaVtt","arrow":"ArrowButton_arrow__mOR5t","right":"ArrowButton_right__0SkU7"};